import angular from 'angular';

import {
  generalConfig,
  qConfig,
  routesConfig,
  routesStatesFormsConfig,
  routesStatesHomeConfig,
  routesStatesMediaConfig,
  routesStatesMiscConfig,
  routesStatesNfeConfig,
  routesStatesReportsConfig,
  routesStatesSecurityConfig,
  routesStatesWorkflowConfig,
  translationsConfig,
} from '../configs';

const module = 'app.configs';
const requires = [];

angular.module(module, requires);
angular.module(module).registerComponents(
  {
    translationsConfig,
    generalConfig,
    qConfig,
    routesConfig,
    routesStatesFormsConfig,
    routesStatesHomeConfig,
    routesStatesMediaConfig,
    routesStatesMiscConfig,
    routesStatesNfeConfig,
    routesStatesReportsConfig,
    routesStatesSecurityConfig,
    routesStatesWorkflowConfig,
  },
  'config'
);
